const Channel = {
  ETHEREUM: 'ETHEREUM',
  TRON: 'TRON',
  SOLANA: 'SOLANA',
  BSC: 'BSC',
  XRP: 'XRP',
};

const ChannelValueEnum = {
  ETHEREUM: 'ERC',
  TRON: 'TRC',
  SOLANA: 'SOLANA',
  BSC: 'BSC',
  XRP: 'XRP',
};

const ChannelSelect = [
  {
    label: 'ERC',
    value: Channel.ETHEREUM,
  },
  {
    label: 'TRC',
    value: Channel.TRON,
  },
  {
    label: 'SOLANA',
    value: Channel.SOLANA,
  },
  {
    label: 'BSC',
    value: Channel.BSC,
  },
  {
    label: 'XRP',
    value: Channel.XRP,
  },
];

const Token = {
  USDT: 'USDT',
  SOL: 'SOL',
  ETH: 'ETH',
  TRX: 'TRX',
  BNB: 'BNB',
  BUSD: 'BUSD',
  USDC: 'USDC',
  XRP: 'XRP',
};

const MchToken = {
  USDT: 'USDT',
  TRX: 'TRX',
  BUSD: 'BUSD',
  USDC: 'USDC',
  ETH: 'ETH',
  XRP: 'XRP',
};

const AgentToken = [
  {
    label: 'USDT',
    value: Token.USDT,
  },
  {
    label: 'BUSD',
    value: Token.BUSD,
  },
  {
    label: 'USDC',
    value: Token.USDC,
  },
  {
    label: 'TRX',
    value: Token.TRX,
  },
  {
    label: 'XRP',
    value: Token.XRP,
  },
];

const CollectToken = {
  USDT: 'USDT',
  TRX: 'TRX',
  BUSD: 'BUSD',
  USDC: 'USDC',
  ETH: 'ETH',
  XRP: 'XRP',
};

const TokenSelect = [
  {
    label: 'USDT',
    value: Token.USDT,
  },
  {
    label: 'ETH',
    value: Token.ETH,
  },
  {
    label: 'TRX',
    value: Token.TRX,
  },
  {
    label: 'SOL',
    value: Token.SOL,
  },
  {
    label: 'BNB',
    value: Token.BNB,
  },
  {
    label: 'BUSD',
    value: Token.BUSD,
  },
  {
    label: 'USDC',
    value: Token.USDC,
  },
  {
    label: 'XRP',
    value: Token.XRP,
  },
];

/**
 * 停用 / 棄用 / 鏈上清空目前只做得動 TRON。
 *
 * 後端 abandon-mch-wallet 一路把 channel 寫死成 'TRON'(abandon-merchant.app.ts、
 * chain-sweep.app.ts),BSC/ERC 的錢包查不到任何一列,按了只會回 notFound、
 * 什麼都沒改。與其讓人按了以為有效,不如把鈕鎖起來講清楚。
 */
const RETIRE_SUPPORTED_CHANNELS = [Channel.TRON];

const isRetireSupported = (channel?: string) =>
  RETIRE_SUPPORTED_CHANNELS.includes(String(channel ?? '').toUpperCase());

const RETIRE_UNSUPPORTED_HINT = '僅支援 TRON';

export {
  Channel,
  Token,
  ChannelSelect,
  ChannelValueEnum,
  TokenSelect,
  CollectToken,
  MchToken,
  AgentToken,
  RETIRE_SUPPORTED_CHANNELS,
  isRetireSupported,
  RETIRE_UNSUPPORTED_HINT,
};
